import Vue from 'vue';
import { IonicVueRouter } from '@ionic/vue';

import Feed from './views/Feed.vue';
import Main from './views/Main.vue';
import Splash from './views/Splash.vue';
import AlertDate from './components/AlertDate.vue';
import AlertBy from './components/AlertBy.vue';

Vue.use(IonicVueRouter);

export default new IonicVueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
    },
    {
      path: '/feed',
      name: 'feed',
      component: Feed,
    },
    {
      path: '/splash',
      name: 'splash',
      component: Splash,
    },
    {
      path: '/alerts',
      name: 'alerts',
      component: () => import(/* webpackChunkName: "alerts" */ './views/Alerts.vue'),
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import(/* webpackChunkName: "signup-success" */ './views/SignUp.vue'),
    },
    {
      path: '/signup/success',
      name: 'signup-success',
      component: () => import(/* webpackChunkName: "signup-success" */ './views/SignUpSuccess.vue'),
      props: true
    },
    {
      path: '/location',
      name: 'location',
      component: () => import(/* webpackChunkName: "location" */ './views/Location.vue'),
    },
    {
      path: '/location-region',
      name: 'location-region',
      component: () => import(/* webpackChunkName: "location-region" */ './views/LocationRegion.vue'),
    },
    {
      path: '/location-city',
      name: 'location-city',
      component: () => import(/* webpackChunkName: "location-city" */ './views/LocationCity.vue'),
    },
    {
      path: '/federated-signin',
      name: 'federated-signin',
      component: () => import(/* webpackChunkName: "federated-signin" */ './views/FederatedSignIn.vue'),
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import(/* webpackChunkName: "profile" */ './views/Profile.vue'),
    },
    {
      path: '/deal/:id',
      name: 'deal',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "deal" */ './views/Deal.vue'),
    },
    {
      path: '/confirm/:uid/:code',
      name: 'confirm',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "confirm" */ './views/Confirm.vue'),
    },
    {
      path: '/reset/:uid/:code',
      name: 'reset',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "reset" */ './views/Reset.vue'),
    },
    {
      path: '/add-alert',
      component: () => import(/* webpackChunkName: "add-alert" */ './views/AddAlert.vue'),
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'add-alert-by',
          component: AlertBy
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'activity',
          name: 'add-alert-activity',
          component: () => import(/* webpackChunkName: "add-alert-activity" */ './components/AlertActivity.vue'),
          props: true
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'region',
          name: 'add-alert-region',
          component: () => import(/* webpackChunkName: "add-alert-region" */ './components/AlertRegion.vue'),
          props: true
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'city',
          name: 'add-alert-city',
          component: () => import(/* webpackChunkName: "add-alert-city" */ './components/AlertCity.vue'),
          props: true
        },
        {
          // UserPosts will be rendered inside User's <router-view>
          // when /user/:id/posts is matched
          path: 'date',
          name: 'add-alert-date',
          component: AlertDate,
          props: true
        }
      ]
    },
    {
      path: '*',
      component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue'),
    }
  ],
});
